import React, { Component } from 'react';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import {
    GoogleMap,
    Marker,
    Polyline
} from '@react-google-maps/api';
import { isRTL } from '../../../helpers/formatLocale';
import { googleMapLoader } from '../../../helpers/googleMapLoader';

import originMarker from '/public/dashboard/originMarker.svg';
import destinationMarker from '/public/dashboard/destinationMarker.svg';
import stopMarker from '/public/dashboard/defaultIconMenu.svg';

const refs = {}
class ShowMap extends Component {
    static defaultProps = {
        zoom: 4,
        height: '400px',
        width: '100%',
        center: { lat: 37.0902, lng: -95.7129 }
    };

    constructor(props) {
        super(props);
        this.state = {
            googleMapsApiLoaded: false,
        }
    }

    async componentDidMount() {
        const autocompleteService = await googleMapLoader();
        this.setState({ googleMapsApiLoaded: true });
        this.autocompleteService = autocompleteService;
    }

    onPolygonLoad = (map) => {
        const { mapMarkerPoints, sw_lat, sw_lng, ne_lat, ne_lng } = this.props;
        let bounds, new_sw, new_ne;
        bounds = new google.maps.LatLngBounds();
        if (map && mapMarkerPoints?.length > 0) {
            mapMarkerPoints.forEach((i) => {
                bounds.extend(new google.maps.LatLng(parseFloat(i.lat), parseFloat(i.lng)));
            });
        }
        if (sw_lat && sw_lng && ne_lat && ne_lng) {
            new_sw = new google.maps.LatLng(sw_lat, sw_lng);
            new_ne = new google.maps.LatLng(ne_lat, ne_lng);
            bounds.extend(new_sw);
            bounds.extend(new_ne);
        }
        if (map) map.fitBounds(bounds);
        refs.map = map;
    }

     getMarkerIcon = (url) => ({
        url,
        scaledSize: new google.maps.Size(50, 50),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(20, 30),
      });

    render() {
        const { mapMarkerPoints, mapRouteDirections, zoom, height, width, center, locale, radius } = this.props;
        const { googleMapsApiLoaded } = this.state;
        let mapStyles = [
            {
                featureType: "poi",
                elementType: "geometry",
                stylers: [
                    {
                        color: "#eeeeee",
                    },
                ],
            },
            {
                featureType: "poi",
                elementType: "labels.text",
                stylers: [
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                featureType: "water",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#9e9e9e",
                    },
                ],
            },
        ];

        const containerStyle = {
            width: width ? width : '100%',
            height: height ? height : '400px',
            borderRadius: radius,
        };


        return (
            <div>
                {googleMapsApiLoaded ?
                    <GoogleMap
                        ref={(map) => this.map = map}
                        zoom={zoom}
                        center={center}
                        mapContainerStyle={containerStyle}
                        onLoad={this.onPolygonLoad}
                        onBoundsChanged={this.onPolygonLoad(refs.map)}
                        options={{
                            styles: mapStyles,
                            disableDefaultUI: true,
                            zoomControl: true,
                            zoomControlOptions: {
                                position: isRTL(locale) ? google.maps.ControlPosition.RIGHT_BOTTOM : google.maps.ControlPosition.LEFT_BOTTOM
                            }
                        }}
                    >
                        {
                            mapRouteDirections && mapMarkerPoints && mapMarkerPoints.length > 0 && mapMarkerPoints.map((position, index) => (
                                <Marker
                                key={index}
                                position={{
                                  lat: Number(position.lat),
                                  lng: Number(position.lng),
                                }}
                                icon={
                                  index === 0
                                    ? this.getMarkerIcon(originMarker)
                                    : index === mapMarkerPoints.length - 1
                                    ? this.getMarkerIcon(destinationMarker)
                                    : this.getMarkerIcon(stopMarker)
                                }
                              />
                              
                            ))
                        }
                        {
                            mapRouteDirections && <Polyline
                                path={mapRouteDirections}
                                options={{
                                    geodesic: true
                                }}
                            />
                        }
                    </GoogleMap> : <></>}
            </div>
        )
    }
}

const mapState = state => ({
    locale: state.intl.locale
});

const mapDispatch = {
    change
};

export default connect(mapState, mapDispatch)(ShowMap);